





















import Vue from "vue";
import Component from "vue-class-component";
import urls from "@/web_client/urls";
import { IMapsUrls } from "@/web_client/interfaces";
import { maps } from "@/store";
import { LTileLayer } from "vue2-leaflet";
import MarineLayer from "./MarineLayer.vue";

@Component({
  components: {
    LTileLayer,
    MarineLayer,
  },
})
export default class TileLayers extends Vue {
  osmUrl: IMapsUrls = urls.mapsUrls.osm;
  darkUrl: IMapsUrls = urls.mapsUrls.darkmap;
  topoUrl: IMapsUrls = urls.mapsUrls.topomap;

  get baseLayer() {
    return maps.getters.baseLayer;
  }
}
